<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>正版图书购买</h3>
				</div>
				<div class="info-content" v-html="infoText">
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
	export default {
        data() {
            return {
                infoText: `<p>"网上书城"是特规通面向特种设备从业者打造的<strong>正版法规标准与专业图书采购平台</strong>，通过与中国标准出版社等十余家专业出版社合作，提供覆盖行业常用法规、标准及技术资料的正版资源，满足企业合规审查、体系建设、项目投标与个人学习提升等多类需求。平台的图书销售与履约服务由合作伙伴<strong>北京品读文化发展有限公司</strong>提供。品读文化深耕特种设备法规标准发行服务，已累计服务行业<strong>2万余家</strong>客户，具备成熟的供货能力与专业客服支持，确保采购过程更省心、交付更可靠。</p><h3>正版合规：来源可查、支持发票、可验真</h3><p>书城坚持以<strong>官方授权与出版社正版渠道</strong>为基础，支持开具发票，便于企业采购合规入账与审计留档。平台同时提供<strong>在线正版查验</strong>能力，帮助用户快速核验购买资源的正规来源与版权信息，降低"来源不明、版本不清、引用风险"的隐患，让合规采购更透明、更可控。</p><h3>采购更灵活：纸质书+电子版，满足不同使用场景</h3><p>平台同时提供<strong>实体纸质书</strong>与<strong>电子版PDF</strong>两种形态：</p><ul><li>纸质书适合档案留存、评审会查阅、现场翻阅与培训资料配发；</li><li>电子版适合随身携带、快速检索与跨团队协同使用。 </br>用户可按企业内控要求、岗位使用习惯与预算安排灵活选择，让"买得到、用得上、管得住"。</li></ul><h3>更有价格优势：常态优惠+批量更优，采购越多越省</h3><p>在保证正版与服务质量的前提下，平台提供更具竞争力的价格与多样化优惠机制（如活动优惠、组合优惠、会员权益等），帮助企业和个人以更划算的方式获取所需资料。对于企业用户的<strong>批量采购</strong>需求，平台支持专属客服对接，提供<strong>更有力度的阶梯优惠与采购方案</strong>，在满足合规采购的同时进一步降低资料成本。</p><h3>版权保护与购买权益：加密交付，下载便捷</h3><p>平台对电子版法规标准采用加密处理，兼顾版权保护与购买者权益。用户购买电子版后，可在平台随时下载加密PDF，便于在授权范围内反复获取与使用（具体下载与使用规则以平台说明为准），避免"文件丢失、反复索取、版本混乱"等问题，提升资料管理效率。</p><h3>买书即送阅读：在线阅读更便捷</h3><p>为提升使用体验，平台对已收录的正版电子资源提供配套服务：用户购买后（无论购买纸质版或电子版），均可获得相应的<strong>在线阅读权益</strong>，方便随时查阅、快速定位内容，帮助把"采购"真正转化为"高频可用"的工作能力（权益范围与期限以平台规则为准）。</p><p></p><p>总体而言，"网上书城"把<strong>正版资源、优惠采购、专业服务、验真开票与安全交付</strong>整合为一体，让特种设备行业用户能以更便捷、更安心、更划算的方式获得所需法规标准与专业图书，为合规审查与技术学习提供稳定支持。</p>`
            }
        }
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		margin-left: 20px;
		padding: 20px 0 !important;
		font-size: 14px;
		color: #686f83;
		line-height: 1.8;
		background-color: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 15px;
		 min-height: calc(100vh - 120px);
		h3 {
			margin: 0 0 10px;
			font-weight: 400;
			font-size: 24px;
			color: #333333;
		}
	}
	.info-item {
		margin-bottom: 20px;
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px solid #cccccc;
		.topbox {
			color: #888888;
			dd {
				margin: 0 30px 0 0;
			}
		}
	}
</style>

<style lang="less">
	.info-content {
        // text-indent: 2em;
        padding: 0 30px;
	}

	.info-content p {
		margin: 0;
	}

	.info-content h5 {
		color: #1f2329;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #1f2329;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}
	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #1474e2;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}
</style>
